import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    CreateButton,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
} from 'react-admin';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TaskListContent } from './TaskListContent';
import { TaskListFilter } from './TaskListFilter';
import { useTaskDrawer } from '../drawer/TaskDrawer';

interface TaskListLayoutProps {
    disableSaveQuery?: boolean;
}

export const TaskListLayout = ({ disableSaveQuery }: TaskListLayoutProps) => {
    const { openDrawer } = useTaskDrawer();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const state = location.state as {
            openCreateDrawer?: boolean;
            assignedMemberId?: string;
            taskId?: string | number;
        } | null;
        if (state?.openCreateDrawer) {
            openDrawer('create', null, state.assignedMemberId ?? null);
            navigate(location.pathname, { replace: true, state: {} });
        } else if (state?.taskId != null) {
            openDrawer('edit', state.taskId);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, navigate, openDrawer]);

    const openCreateDrawer = (assignedMemberId?: string | null) =>
        openDrawer('create', null, assignedMemberId ?? null);
    const openEditDrawer = (id: string | number) => openDrawer('edit', id);

    return (
        <Stack direction="row">
            <TaskListFilter
                disableSaveQuery={disableSaveQuery}
                sx={{ mt: 2 }}
            />
            <Stack sx={{ width: '100%' }}>
                <Title title={'task'} />
                <ListToolbar
                    actions={
                        <TaskListActions openCreateDrawer={openCreateDrawer} />
                    }
                />
                <BulkActionsToolbar>
                    <BulkDeleteButton />
                </BulkActionsToolbar>
                <Card>
                    <TaskListContent openEditDrawer={openEditDrawer} />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const TaskListActions = ({
    openCreateDrawer,
}: {
    openCreateDrawer: (assignedMemberId?: string | null) => void;
}) => (
    <TopToolbar>
        <SortButton fields={['dueDate', 'updatedAt', 'createdAt']} />
        <CreateButton
            variant="contained"
            label="New Task"
            onClick={() => openCreateDrawer()}
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
